import * as type from "../constants/PostActionTypes";
import {
  filtersToQueryString
} from "../../utils/post-filter";

export const getListPost = (filters) => {
  if((filters.search && filters.search.value == "")  && (filters.start_date && filters.start_date.value == "")){
    filters = {
      ...filters,
      created_start_date: {
        fieldName: "createdAt_gte",
        value: "2025-01-01T00:00:00"
      },
    }
  }
  let queryString = filtersToQueryString(filters);

  let sortField = "modifiedAt";
  if (filters.status && filters.status.value == "da-len-lich") {
    sortField = "scheduleAt";
  }
  if (filters.status && filters.status.value == "da-dang") {
    sortField = "publishedAt";
  }

  return {
    types: [
      type.GET_LIST_POST,
      type.GET_LIST_POST_SUCCESS,
      type.GET_LIST_POST_FAIL,
    ],
    promise: (client) =>
      client.get(`/posts?_sort=${sortField}:DESC${queryString}`),
  };
};

export const getListPostReviewSEO = (filters) => {
  let queryString = filtersToQueryString(filters);

  let sortField = "modifiedAt";
  if (filters.status && filters.status.value == "da-len-lich") {
    sortField = "scheduleAt";
  }
  if (filters.status && filters.status.value == "da-dang") {
    sortField = "publishedAt";
  }

  return {
    types: [
      type.GET_LIST_POST,
      type.GET_LIST_POST_SUCCESS,
      type.GET_LIST_POST_FAIL,
    ],
    // posttype_in including da-dang(ready) and doi-duyet(waiting)
    // google=true to get google's title and description
    promise: (client) => client.get(`/posts?_sort=${sortField}:DESC${queryString}&posttype_in=5e80d484c38ec834dcbd98d0&posttype_in=5e80d49cc38ec834dcbd98d1&google=true`),
  };
};

export const getListRoyalties = (filters) => {
  let queryString = filtersToQueryString(filters);

  let prField = "pr_type=0";
  if (filters.editor_type && filters.editor_type.value == "pr") {
    prField = "";
  }
  return {
    types: [
      type.GET_LIST_ROYALTIES,
      type.GET_LIST_ROYALTIES_SUCCESS,
      type.GET_LIST_ROYALTIES_FAIL,
    ],
    promise: (client) =>
      client.get(`/posts/rolyalties?${prField}${queryString}`),
  };
};

export const getListRoyaltiesMoney = (filters) => {
  let queryString = filtersToQueryString(filters);

  let prField = "pr_type=0";
  if (filters.editor_type && filters.editor_type.value == "pr") {
    prField = "";
  }
  return {
    types: [
      type.GET_LIST_ROYALTIES_MONEY,
      type.GET_LIST_ROYALTIES_MONEY_SUCCESS,
      type.GET_LIST_ROYALTIES_MONEY_FAIL,
    ],
    promise: (client) =>
      client.get(`/posts/money?${prField}${queryString}`),
  };
};

export const countListPost = (filters) => {
  let queryString = filtersToQueryString(filters);
  return {
    types: [
      type.COUNT_LIST_POST,
      type.COUNT_LIST_POST_SUCCESS,
      type.COUNT_LIST_POST_FAIL,
    ],
    promise: (client) =>
      client.get(`/posts/count?_sort=_id:DESC${queryString}`),
  };
};

export const getPostById = (value) => ({
  types: [type.GET_POST, type.GET_POST_SUCCESS, type.GET_POST_FAIL],
  promise: (client) => client.get(`/posts/get-detail/` + value),
});

export const createPost = (value) => ({
  types: [type.ADD_NEW_POST, type.ADD_NEW_POST_SUCCESS, type.ADD_NEW_POST_FAIL],
  promise: (client) => client.post(`/posts`, value),
});

export const updatePost = (value) => ({
  types: [type.UPDATE_POST, type.UPDATE_POST_SUCCESS, type.UPDATE_POST_FAIL],
  promise: (client) => client.put(`/posts/${value._id}`, value),
});

export const deletePost = (value) => ({
  types: [type.DELETE_POST, type.DELETE_POST_SUCCESS, type.DELETE_POST_FAIL],
  promise: (client) => client.delete(`/posts/${value._id}`),
});

export const setCurrentPost = (value) => ({
  type: type.SET_CURRENT_POST,
  value,
});

export const setSelectedValue = (value) => ({
  type: type.SET_SELECTED_VALUE,
  value,
});

export const changeTab = (value) => ({
  type: type.CHANGE_TAB_POST,
  value,
});

export const updatePostFromSocket = (value) => ({
  type: type.UPDATE_POST_FOROM_SOCKET,
  value,
});
export const updateListPost = (value) => ({
  type: type.UPDATE_LIST_POST,
  value,
});
